import classNames from 'classnames';
import { Seller } from './sellerDirectory';
import { Drawer, Skeleton } from '@iwoca/orion';
import styles from './sellerDirectory.module.css';
import { tracking } from '@iwoca/frontend-tracking-library';

export const Filters = ({
    sellers,
    selectedFilter,
    setSelectedFilter
}: {
    sellers?: Seller[];
    selectedFilter: string | null;
    setSelectedFilter: (name: string | null) => void;
}) => {
    return (
        <section className="font-reg">
            <h2>Filter suppliers by type</h2>
            <FilterList
                sellers={sellers}
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
            />
        </section>
    );
};

export const FilterDrawer = ({
    isOpen,
    onClose,
    sellers,
    selectedFilter,
    setSelectedFilter
}: {
    isOpen: boolean;
    onClose: () => void;
    sellers?: Seller[];
    selectedFilter: string | null;
    setSelectedFilter: (name: string | null) => void;
}) => {
    return (
        <Drawer
            isOpen={isOpen}
            onClose={onClose}
            title="Filter by suppliers type"
            className={styles.filterDrawer}
        >
            <FilterList
                sellers={sellers}
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
                onSelect={onClose}
            />
        </Drawer>
    );
};

const FilterList = ({
    sellers,
    selectedFilter,
    setSelectedFilter,
    onSelect
}: {
    sellers?: Seller[];
    selectedFilter: string | null;
    setSelectedFilter: (name: string | null) => void;
    onSelect?: () => void;
}) => {
    const categories = Object.entries(
        (sellers || []).reduce<{ [key: string]: number }>(
            (categories, { category }) => {
                categories[category] = (categories[category] || 0) + 1;
                return categories;
            },
            {}
        )
    ).sort(([a], [b]) => a.localeCompare(b));

    const selectFilter = (filter: string | null) => {
        setSelectedFilter(filter);
        onSelect?.();
    };

    return (
        <div className="flex flex-col gap-s">
            {sellers ? (
                <>
                    <Filter
                        name="Directory suppliers"
                        count={sellers?.length || 0}
                        selected={selectedFilter === null}
                        setSelectedFilter={() => selectFilter(null)}
                    />
                    {categories.map(([name, count], i) => (
                        <Filter
                            key={i}
                            name={name}
                            count={count}
                            selected={name === selectedFilter}
                            setSelectedFilter={() => selectFilter(name)}
                        />
                    ))}
                </>
            ) : (
                Array(14)
                    .fill(null)
                    .map((_, i) => <LoadingFilter key={i} />)
            )}
        </div>
    );
};

const Filter = ({
    name,
    count,
    selected,
    setSelectedFilter
}: {
    name: string;
    count: number;
    selected: boolean;
    setSelectedFilter: () => void;
}) => {
    const trackFilterClick = () => {
        tracking.ampli.sellerDirectoryFilterClicked({
            filter_name: name
        });
    };

    return (
        <button
            className={classNames(
                'row flex w-full justify-between rounded-s px-l py-s hover:bg-secondary-97',
                {
                    'border-2 border-solid border-primary-40 bg-secondary-97 font-med':
                        selected
                },
                {
                    'border-2 border-solid border-transparent bg-transparent font-reg':
                        !selected
                }
            )}
            onClick={() => {
                setSelectedFilter();
                trackFilterClick();
            }}
        >
            <span className="capitalize">{name}</span>
            <span>{count}</span>
        </button>
    );
};

const LoadingFilter = () => {
    return (
        <div className={'row flex rounded-s px-l py-s hover:bg-secondary-97'}>
            <Skeleton />
        </div>
    );
};
